import VideoDashboard from '../../../components/video-manager/VideoDashboard';

const Videos = () => {
  return (
    <VideoDashboard />
  )
}

export default Videos